"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenArrayOfArrays = void 0;
/**
 * recursive. doesnt matter how many arrays exist inside.
 * array.flat(Infinity) does the same thing
 */
var flattenArrayOfArrays = function (_a) {
    var array = _a.array, _b = _a.flattenLastArray, flattenLastArray = _b === void 0 ? true : _b, _c = _a.toReturn, toReturn = _c === void 0 ? [] : _c;
    array.map(function (ary) {
        if (Array.isArray(ary)) {
            if (flattenLastArray === true) {
                //check if this is the last array. 
                if (ary.some(function (childAry) { return !Array.isArray(childAry); })) { //if one of its children is NOT an array, then we consider this the last array
                    toReturn.push(ary);
                }
                else {
                    (0, exports.flattenArrayOfArrays)({ array: ary, flattenLastArray: flattenLastArray, toReturn: toReturn });
                }
            }
            else { //flatten last ary is true, so continue as normal
                (0, exports.flattenArrayOfArrays)({ array: ary, flattenLastArray: flattenLastArray, toReturn: toReturn });
            }
        }
        else {
            toReturn.push(ary);
        }
    });
    return toReturn;
};
exports.flattenArrayOfArrays = flattenArrayOfArrays;
